import React from 'react'
import { Icon, Tag } from 'antd'
import * as _ from 'lodash'

import { ComponentExt } from 'util/reactExt'
import { RouteComponentProps } from 'react-router'
import ListRender from './components/listRender'

import * as styles from './index.scss'

interface IProps extends RouteComponentProps<any> {}
interface IState {}

// 经传家事
class Housework extends ComponentExt<IProps, IState> {
  state = {
    listType: 0,
    list: [],
    listLen: 0,
    tags: [],
    recommendList: [],
  }

  async componentDidMount() {
    this.handleRequestList()
  }

  // tslint:disable-next-line: variable-name
  handleRequestList = (params = { label_type: 1 }) => {
    this.handleFetchArticleList(params)
    this.handleFetchHotArticleList(params)
    this.handleFetchLabelList(params)
  }

  async handleFetchArticleList(params: {
    label_type?: number
    label_id?: number
    type?: number
    page?: number
    limit?: number
  }) {
    try {
      const {
        list,
        count: listLen,
      } = await this.api.family.getFamilyArticleList(params)
      this.setState({
        list: list,
        listLen,
      })
    } catch (err) {
      console.error(err.message)
    }
  }

  async handleFetchHotArticleList(params: {
    label_type: number
    type?: number
    limit?: number
  }) {
    try {
      const recommendList = await this.api.family.getFamilyHotArticleList(
        params,
      )
      this.setState({
        recommendList,
      })
    } catch (err) {
      console.error(err.message)
    }
  }

  async handleFetchLabelList(params: { label_type: number }) {
    try {
      const tags = await this.api.family.getFamilyLabelList(params)
      this.setState({ tags })
    } catch (err) {
      console.error(err.message)
    }
  }

  handleSliceString = (str, limit = 30) => {
    let res = str
    if (str && str.length > limit) {
      res = `${str.slice(0, limit)}···`
      return res
    }
    return res
  }

  handleClickMenu = e => {
    let params
    if (e.key === 'news') {
      params = {
        label_type: 1,
      }
      delete params.type
    } else {
      params = {
        label_type: 1,
        type: Number(e.key),
      }
      this.setState({ listType: Number(e.key) })
    }
    this.handleRequestList(params)
  }

  handleClickList = (e, data, type) => {
    // 阻止冒泡
    e.stopPropagation()
    const WINOPEN = url => {
      window.open(window.location.origin + url, '_blank')
    }
    if (type === 'li') {
      WINOPEN(`#/housework/detail/${type}?id=${data.id}`)
    } else if (type === 'tag') {
      WINOPEN(
        `#/housework/list/${type}?tagName=${data.label_name}&labelId=${data.id}`,
      )
    }
  }

  handleCheckTag = data => {
    const { listType } = this.state
    window.open(
      window.location.origin +
        `#/housework/list/tag?tagName=${data.label_name}&labelId=${data.id}&listType=${listType}`,
      '_blank',
    )

    // this.props.history.push(
    //   `housework/list/tag?tagName=${data.label_name}&labelId=${data.id}&listType=${listType}`,
    // )
  }

  handleRenderList = () => {
    const { list } = this.state
    if (_.isEmpty(list)) {
      return
    }
    return _.map(list, (itm, idx) => (
      <li
        className={itm.type === '1000101' ? styles.vdBg : null}
        onClick={e => this.handleClickList(e, itm, 'li')}
        key={itm.id}
      >
        <div className={styles.listImg}>
          <img
            src={
              itm.img_url ||
              'http://xy-v.jingzhuan.cn/image/dbcc47bdb414b2bb78ac3727ab565e16.png'
            }
            alt=""
          />
        </div>
        <div className={styles.listContent}>
          <h4>
            {this.handleSliceString(itm.title)}
            {itm.type === '1000101' && <Icon type="play-square" />}
          </h4>
          <p style={{ minHeight: '44px' }}>
            {this.handleSliceString(itm.article_desc, 50)}
          </p>
          <span>{itm.publish_date.split(' ')[0]}</span>
          {itm.label.length > 0 &&
            _.map(itm.label, item => (
              <span
                onClick={e => this.handleClickList(e, item, 'tag')}
                key={item.id}
                className={styles.listTag}
              >{`#${item.label_name}`}</span>
            ))}
        </div>
      </li>
    ))
  }

  handleRenderTag = () => {
    const { tags } = this.state
    if (_.isEmpty(tags)) {
      return
    }

    return _.map(tags, itm => (
      <Tag key={itm.id} onClick={() => this.handleCheckTag(itm)}>
        {itm.label_name}
      </Tag>
    ))
  }

  handleRenderRecommend = () => {
    const { recommendList } = this.state
    if (_.isEmpty(recommendList)) {
      return
    }
    return _.map(recommendList, (itm, idx) => {
      if (idx === 0) {
        return (
          <li key={itm.id} onClick={e => this.handleClickList(e, itm, 'li')}>
            <img src={itm.img_url} alt={itm.article_desc} />
            <p>
              {this.handleSliceString(itm.title)}
              {itm.type === '1000101' && <Icon type="play-square" />}
            </p>
          </li>
        )
      }
      return (
        <li key={itm.id} onClick={e => this.handleClickList(e, itm, 'li')}>
          <p>
            {this.handleSliceString(itm.title)}
            {itm.type === '1000101' && <Icon type="play-square" />}
          </p>
        </li>
      )
    })
  }

  render() {
    const that = this
    const {
      state: { listLen },
      handleRenderList,
      handleRenderTag,
      handleRenderRecommend,
      handleClickMenu,
    } = this
    const mapListRenderProps: any = {
      that,
      listLen,
      handleRenderList,
      handleRenderTag,
      handleRenderRecommend,
      handleClickMenu,
    }
    return (
      <div className={styles.housework}>
        <div className={styles.topicImg}>
          <img src="https://imgs.n8n8.cn/fund_20191126142732689.png" />
        </div>
        <div className={styles.content}>
          <ListRender {...mapListRenderProps} />
        </div>
      </div>
    )
  }
}

export default Housework
